import { Link, MenuItem, Select, styled } from "@material-ui/core";
import { useState } from "react";
import { lang } from "../../../i18nLang";
import DateRangePickerField from "../../UI/Fields/DateRangePickerField";

const SelectCustom = styled(Select)({
  width: "100%",
  "& > .MuiOutlinedInput-input": {
    padding: "10px 9px",
  },
});

export const PeriodLink = ({
  id,
  initialDate,
  finalDate,
  onChange,
}: {
  id: string;
  initialDate: Date;
  finalDate: Date;
  onChange: (dates: { start: Date; end: Date }) => void;
}) => {
  const [open, setOpen] = useState(false);
  const name = `period-date-${id}`;
  const period = `${initialDate.toLocaleDateString(
    "pt-br"
  )} a ${finalDate.toLocaleDateString("pt-br")}`;

  const hadleOpenPicker = () => setOpen(true);
  const hadleClosePicker = () => setOpen(false);

  const handleClickDate = (ev) => {
    ev.preventDefault();
    hadleOpenPicker();
  };

  const handleOnChange = (dates) => {
    if (dates.start && dates.end) onChange(dates);
  };

  return (
    <>
      <Link
        href="#"
        onClick={handleClickDate}
        color="inherit"
        underline="always"
      >
        {period}
      </Link>
      <DateRangePickerField
        name={name}
        initialDate={initialDate}
        finalDate={finalDate}
        onChange={handleOnChange}
        open={open}
        onOpen={hadleOpenPicker}
        onClose={hadleClosePicker}
        style={{ display: "none" }}
      />
    </>
  );
};

export const StatusSelect = ({
  value,
  options,
  onChange,
}: {
  value: string;
  options: string[];
  onChange: (ev) => void;
}) => (
  <SelectCustom
    name="status"
    value={value}
    variant="outlined"
    onChange={onChange}
  >
    {options.map((status) => (
      <MenuItem key={status} value={status}>
        {lang(`measurements.status.${status}`)}
      </MenuItem>
    ))}
  </SelectCustom>
);
